import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'util/i18n';
import { connect } from 'react-redux';
import { Modal } from 'components/Modal';
import env from 'config/environment';

const Logout = ({ loginRedirect }) => (
  <Modal className="logout-modal" show>
    <div className="table one">
      <div id="logout" className="logout auth denied">
        <h2>{i18n.t('logout.title')}</h2>
        {i18n.m('logout.para')}
        <a
          href={(env.SamlEnabled() && env.Saml2Enabled()) || !loginRedirect ? '/login' : loginRedirect}
          className="usa-button-primary usa-button-big"
          aria-label={i18n.t('login.token.button')}
        >
          {i18n.t('login.token.button')}
        </a>
      </div>
    </div>
  </Modal>
);

Logout.defaultProps = {
  loginRedirect: '',
};

Logout.propTypes = {
  loginRedirect: PropTypes.string,
};

function mapStateToProps(state) {
  const loginRedirect = state?.api?.fetchEnvironment?.response?.loginRedirect || '';
  return {
    loginRedirect,
  };
}

export default connect(mapStateToProps)(Logout);
